// src/components/strumenti/CapacitaBatteria.js — W442. Capacità delle batterie della centrale
import React from "react";
import { useCampi, Campo, Griglia, Risultato, Formula, Azzera, fmt } from "./UiStrumento";
import { capacitaBatteria } from "../../utils/calcoliStrumenti";

export default function CapacitaBatteria() {
  const { v, set, n, azzera } = useCampi({ ir:"", hr:"12", ia:"", ha:"0.5", f:"0.8" });
  // correnti scritte in mA, come nei datasheet; il calcolo è in A
  const r = capacitaBatteria(n("ir") / 1000, n("hr"), n("ia") / 1000, n("ha"), n("f"));
  return (
    <div>
      <Griglia colonne={2}>
        <Campo etichetta="Assorbimento a riposo (mA)" valore={v.ir} onChange={set("ir")} placeholder="Es. 350" aiuto="Somma di centrale, sensori e tastiere: vedi «Somma assorbimenti»."/>
        <Campo etichetta="Autonomia richiesta a riposo (ore)" valore={v.hr} onChange={set("hr")} placeholder="Es. 12"/>
        <Campo etichetta="Assorbimento in allarme (mA)" valore={v.ia} onChange={set("ia")} placeholder="Es. 1200" aiuto="Con sirene e segnalatori attivi."/>
        <Campo etichetta="Durata dell'allarme (ore)" valore={v.ha} onChange={set("ha")} placeholder="Es. 0,5"/>
        <Campo etichetta="Fattore di efficienza / invecchiamento" valore={v.f} onChange={set("f")} aiuto="0–1: 0,8 tiene conto della perdita di capacità nel tempo."/>
      </Griglia>
      <Risultato settore="antintrusione" titolo="Capacità necessaria" valore={fmt(r?.ah, 2)} unita="Ah"
        righe={r ? [["Taglia commerciale consigliata", r.taglia ? fmt(r.taglia, 1) + " Ah" : "oltre 100 Ah: più batterie"]] : []}/>
      <Formula>Ah = (I riposo × ore a riposo + I allarme × ore di allarme) ÷ fattore. Le autonomie richieste dipendono dal grado dell'impianto e dalla norma applicata (es. CEI EN 50131-6): verificale prima. Controlla che la centrale possa ricaricare la batteria scelta.</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
